var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-more-btn",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"text"},[_vm._v("加载更多")])])}
var staticRenderFns = []

export { render, staticRenderFns }